import { useRef, useState } from "react";
import { Upload, X, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, asset, errMsg } from "@/lib/api";

export function ImageUpload({ value, onChange, multiple = false, testid = "image-upload" }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const list = multiple ? value || [] : value ? [value] : [];
  const pick = async (e) => {
    const files = [...e.target.files];
    if (!files.length) return;
    setBusy(true);
    try {
      const urls = [];
      for (const f of files) {
        const fd = new FormData();
        fd.append("file", f);
        const { data } = await api.post("/admin/upload", fd);
        urls.push(data.url);
      }
      onChange(multiple ? [...list, ...urls] : urls[0]);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };
  return (
    <div className="flex flex-wrap gap-2" data-testid={testid}>
      {list.map((u) => (
        <div key={u} className="relative w-20 h-20 rounded-xl overflow-hidden border">
          <img src={asset(u)} alt="" className="w-full h-full object-cover" />
          <button type="button" onClick={() => onChange(multiple ? list.filter((x) => x !== u) : "")} className="absolute top-1 right-1 w-6 h-6 rounded-full bg-white/90 grid place-items-center" data-testid={`${testid}-remove`}><X className="w-3 h-3" /></button>
        </div>
      ))}
      {(multiple || !list.length) && (
        <button type="button" onClick={() => ref.current?.click()} className="w-20 h-20 rounded-xl border-2 border-dashed grid place-items-center text-slate-400 hover:text-slate-700 hover:border-slate-400" data-testid={`${testid}-button`}>
          {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <Upload className="w-5 h-5" />}
        </button>
      )}
      <input ref={ref} type="file" accept="image/*" multiple={multiple} className="hidden" onChange={pick} data-testid={`${testid}-input`} />
    </div>
  );
}
